<div class="video">
  <iframe [src]="url" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe>
</div>
